import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { createNotification, CustomButton, icon } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import styles from "./ExportImport.module.css";
import { downloadFile } from "../../../../../common/utils";

export default function ExportImport({ currentTab, onExport, onImport, onSuccessImport }) {
	const dispatch = useDispatch();
	const fileInputRef = useRef(null);

	const handleExport = () => {
		onExport()
			.then(({ data, filename }) => {
				downloadFile({ data: JSON.stringify(data, null, 2), filename, filetype: "json" });
			})
			.catch((err) => {
				console.error(err);
			});
	};
	const readFileAsJson = async (file) => {
		const text = await file.text();
		return JSON.parse(text);
	};
	const handleImport = (event) => {
		const file = event.target.files[0];
		if (file && file.type === "application/json") {
			readFileAsJson(file)
				.then((jsonData) => onImport(jsonData))
				.then(() => {
					if (typeof onSuccessImport === "function") {
						dispatch(onSuccessImport(true));
					}
					createNotification({
						type: "success",
						message: "Import successful",
					});
				})
				.catch((err) => {
					console.error(err);
				});
		}
	};

	const wordingExportImport = (funcName) => {
		if (currentTab === 0) {
			return translate(`dsi.agents.agent-models.btn.${funcName}`);
		}
		if (currentTab === 3) {
			return translate(`dsi.agents.workflow-models.btn.${funcName}`);
		}
		return "";
	};

	return (
		<div className={styles.actionButtons}>
			{onImport && (
				<CustomButton
					color="secondary"
					component="label"
					startIcon={icon.faDownload}
					variant="outlined"
					onClick={() => fileInputRef.current?.click()}
				>
					<input hidden accept=".json" type="file" onChange={handleImport} />
					{wordingExportImport("import")}
				</CustomButton>
			)}
			{onExport && (
				<CustomButton color="secondary" startIcon={icon.faUpload} variant="outlined" onClick={handleExport}>
					{wordingExportImport("export")}
				</CustomButton>
			)}
		</div>
	);
}
